/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';
import { View, Text, ScrollView } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone, isWeb } from '@helpers';

import ColorWrapper from '@styles/colors';
import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';

import EditField from '@components/common/editField';
import Header from '@components/settings/v2/common/SettingsHeader';
import TouchableElement from '@components/common/touchableElement';
import Loading, { SmallLoading } from '@components/loading';

import ActionModal from './actionModal';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

import { useManageMachinesGroupDetails } from './hooks/useManageMachinesGroupDetails';

const MachineBlock = ({ i, selectMachine, selectedList, C, elementWidth, index }) => {
  const [saving, setSaving] = useState(false);
  const isSelected = selectedList.includes(i.machineId);

  return (
    <TouchableElement
      onPress={async () => {
        if (saving) {
          return;
        }
        await selectMachine({ machine: i, selected: isSelected, setSaving });
      }}
    >
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              width: isPhone ? '100%' : elementWidth,
              height: scale(48),
              borderRadius: scale(SCREEN_BORDER_RADIUS),
              backgroundColor: C(pressHoverColor('Background/Light/Field')),
              flexDirection: 'row',
              alignItems: 'center',
              paddingHorizontal: scale(12),
              borderWidth: scale(3),
              borderColor: isSelected ? C('Selected/Light/Primary') : C(pressHoverColor('Background/Light/Field')),
              marginBottom: isWeb ? scale(32) : scale(8),
              marginRight: isPhone ? 0 : scale((index + 1) % 3 > 0 ? 32 : 0),
            },
          ]}
        >
          <View style={{ width: scale(24), height: scale(24), justifyContent: 'center', alignContent: 'center' }}>
            {saving ? (
              <SmallLoading />
            ) : isSelected ? (
              <Svg icon="selected" width={scale(24)} height={scale(24)} color="Selected/Light/Primary" />
            ) : (
              <Svg icon="unselected" width={scale(24)} height={scale(24)} color="Label/Light/Quinary" />
            )}
          </View>
          <Text style={[font['Body'], { color: C('Label/Light/Primary'), marginLeft: scale(12) }]} numberOfLines={1}>
            {i.shortName}
          </Text>
        </View>
      )}
    </TouchableElement>
  );
};

const MachinesGroupDetails = ({ C }) => {
  const {
    group,
    machines,
    showMorePopup,
    showEditGroupName,
    elementWidth,
    selectedList,
    setShowMorePopup,
    toggleShowMorePopup,
    toggleEditGroupName,
    selectMachine,
    onEditGroupName,
    removeGroup,
  } = useManageMachinesGroupDetails();

  return [
    <EditField
      key="EditField"
      {...{
        C,
        showModal: showEditGroupName,
        onClose: toggleEditGroupName,
        header: 'Edit Machine Group Name',
        initData: {
          name: group.name,
        },
        onSubmit: onEditGroupName,
        inputs: [
          {
            key: 'name',
            name: 'Name',
            noArrow: true,
            lableWidth: scale(110),
          },
        ],
      }}
    />,
    <View key="mainMachineContent" style={{ height: '100%', width: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <Header
        backBtnText="Groups"
        name={'MachinesGroupDetails'}
        header={group.name}
        action={toggleShowMorePopup}
        actionActive={showMorePopup}
      />
      <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50) }}>
        <View
          style={{
            paddingHorizontal: scale(18),
          }}
        >
          {group.machineGroupId ? (
            <View>
              <View style={{ marginBottom: scale(24) }}>
                <Text style={[font.Headline, { color: C('Label/Light/Primary') }]}>{i18n.t('Select the Machines to include in this group')}</Text>
              </View>
              <View style={{ width: '100%', flexDirection: 'row', flexWrap: 'wrap' }}>
                {machines.map((i, index) => (
                  <MachineBlock
                    key={`machine-${i.machineId}`}
                    {...{ i, index, C, selectMachine, elementWidth, selectedList }}
                  />
                ))}
              </View>
            </View>
          ) : (
            <Loading background={C('Background/Light/Detail')} />
          )}
        </View>
      </ScrollView>
    </View>,
    showMorePopup && (
      <ActionModal
        key="actionModal"
        {...{
          setShowMorePopup,
          toggleEditGroupName,
          removeAction: removeGroup,
        }}
      />
    ),
  ];
};

export default ColorWrapper(MachinesGroupDetails);
